import React from 'react';
import Cta from "./main/Cta";
import Portfolio from "./main/Portfolio";
import AboutStore from "./main/AboutStore";
import SlidePainel from "./main/SlidePainel";
import SlideAdm from "./main/SlideAdm";
import ScrollToTop from "./Gotop";
import Caracteristicas from "./main/Caracteristicas";
import Duvidas from "./main/Duvidas";
import Brinde from "./main/Brinde";
import Seo from "./main/Seo";
import Propaganda from "./main/Propaganda";

export default class Main extends React.Component {

    render(){
        return(
            <div className="main" id="home">
                <AboutStore/>
                <Propaganda/>
                <Caracteristicas/>
                <SlidePainel/>
                <SlideAdm/>
                <Portfolio/>
                <ScrollToTop/>
                <Duvidas/>
                <Seo/>
                <Brinde/>
                <Cta/>
            </div>
        );
    }
}